import {
  Product,
  EmployeeThatProvidesThisService,
  EmployeeAvailabilityHours,
  Appointment,
  DailySpecialResponse,
} from "@/types/product";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const productApi = createApi({
  reducerPath: "productApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API_BASE_URL}api/v1/`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("access_token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getUpsellProducts: builder.query<
      {
        count: number;
        next: string | null;
        previous: string | null;
        results: Product[];
      },
      void
    >({
      query: () => "product?is_upsell=true",
    }),
    getEmployeesThatProvideThisService: builder.query<
      EmployeeThatProvidesThisService[],
      { serviceId: number }
    >({
      query: ({ serviceId }) =>
        `employee/employees_that_provide_this_service/?service_id=${serviceId}`,
    }),
    getEmployeeAvailabilityHours: builder.query<
      EmployeeAvailabilityHours[],
      { employeeId: number }
    >({
      query: ({ employeeId }) =>
        `employee-availability/?employee_id=${employeeId}`,
    }),
    createAppointment: builder.mutation<
      Appointment,
      { employee: number; appointment_time: Date; duration: number }
    >({
      query: (body) => ({
        url: "appointment/",
        method: "POST",
        body,
      }),
    }),
    getDailySpecials: builder.query<DailySpecialResponse, { branchId: string }>(
      {
        query: ({ branchId }) => ({
          url: `${import.meta.env.VITE_API_BASE_URL}discount/daily-special/today/?branch=${branchId}`,
        }),
      },
    ),
  }),
});

export const {
  useGetUpsellProductsQuery,
  useGetEmployeesThatProvideThisServiceQuery,
  useGetEmployeeAvailabilityHoursQuery,
  useCreateAppointmentMutation,
  useGetDailySpecialsQuery,
} = productApi;
